<template>
  <div @click="edit">
    <div>
      <div class="hdr-bold">
        Order: {{order.orderNo}}
      </div>
      <div class="hdr-middle-bold">
        {{order.status}}
      </div>
      <div class="hdr-middle-bold" v-if="order.vendor">
        ({{order.vendor}})
      </div>
      <br/>
    </div>
    <div v-show="order.status !== 'Not Placed'">
       Ordered: {{formattedOrderDate}}
       <div class="in-line" v-if="order.status !== 'Received'">
         Due: {{formattedDueDate}}
       </div>
       <div class="in-line" v-else>
         Received: {{formattedRecvDate}}
       </div>
    </div>
    <div style="display: inline-block;">
        Qty: {{partQty}}
    </div>
    <div class="in-line">
        Each: ${{partCost}}
    </div>
    <div class="in-line" v-show="partQty != 1">
        Total: ${{totalCost}}
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'order-card',

  data () {
    return {
      orderNo: null,
    }
  },
  props: [
    'part',
    'order',
  ],

  methods: {
    edit () {
      console.log('click');
      if(this.$parent.showOrderEditor) {
        this.$parent.showOrderEditor = false;
        return;
      }
      this.$parent.editOrder(this.orderNo);
    },
    delete () {
      this.$parent.showOrderEditor = false;
    }
  },
  computed: {
    partQty () {
      return (this.order.partsPerPack * this.order.packCount).toFixed(0);
    },
    partCost () {
      return (this.totalCost / this.partQty).toFixed(3);
    },
    totalCost () {
      return (this.order.costPerPack * this.order.packCount).toFixed(2);
    },
    formattedOrderDate () {
      return moment(this.order.date).format('M/D/Y');
    },
    formattedRecvDate () {
      return moment(this.order.recv).format('M/D/Y');
    },
    formattedDueDate () {
      return moment((this.order.due1 + this.order.due2)/2)
              .format('M/D/Y');
    },
  },
  created () {
    this.orderNo = this.order.orderNo;
  },
}
</script>

<style scoped>

.order-card {
  margin:10px;
  border: 2px solid lightgray;
  padding: 10px;
}
.hdr-bold {
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  margin-top:5px;
}
.lbl { 
  font-weight: bold;
}
.hdr {
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
}
.hdr-middle-bold {
  font-size: 16px;
  font-weight: bold;
  margin-left: 20px;
  display: inline-block;
}
.hdr-right {
  font-size: 16px;
  font-weight: bold;
  float: right;
}
.in-line {
  display: inline-block;
  margin-left: 10px;
  margin-top: 5px;
}
</style>
